import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  AppointmentBehaviour,
  AppointmentStatus,
  AppointmentStatusNumeric,
} from '@fitness-force/enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'appointment-status',
  templateUrl: './appointment-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class AppointmentStatusComponent implements OnInit {
  activeStatus: any;
  columnData: BehaviorSubject<any> = new BehaviorSubject(null);
  additionData: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() {}

  ngOnInit(): void {
    this.columnData.subscribe({
      next: (cData: any) => {
        let index = 0;
        for (let [key, value] of Object.entries(AppointmentStatusNumeric)) {
          // For report fields
          if (cData?.appt_status && value == cData?.appt_status) {
            this.activeStatus = { name: value, key };
          }
          index++;
        }
      },
    });
  }
}
